import React from "react";
import {useAppText} from "src/commun/composants/AppText";
import {useAppState} from "src/app/state/StateProvider";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import AppIcon from "src/commun/composants/AppIcon";
import stylesServices from "src/pages/listeservices/ListeServices.scss";
import styles from "./BandeauFavoris.scss";
import AppTuileFavori from "src/commun/composants/tuile/AppTuileFavori";
import { ActiveService } from "src/domain/User";

const ListeFavoris = () => {
  const [{ services, favoris }] = useAppState();
  const { tString, t } = useAppText();

  // on ignore les favoris dont le service n'est plus souscrit, sinon une tuile vide s'affiche
  const favorisSouscrits: ActiveService[] = (favoris ?? [])
    .map((favori: string) => services?.servicesSouscrits.find(s => s.serviceCode === favori))
    .filter((service): service is ActiveService => !!service);

  return (
    <>
      <h2 className={styles.favorisTitle}>
        {tString("favoris.libelle")}
      </h2>

      {(favorisSouscrits.length > 0) ? (
        favorisSouscrits.map((favori: ActiveService, index) => (
          <span key={"favori-" + index}>
            {(index % 3 === 0) && (
              <AppRow>
                <AppTuileFavori service={favorisSouscrits[index]}/>
                {favorisSouscrits[index + 1] ?
                  <AppTuileFavori service={favorisSouscrits[index + 1]}/>
                  : <AppCol className={stylesServices.emptyTuileContainer}/>}
                {favorisSouscrits[index + 2] ?
                  <AppTuileFavori service={favorisSouscrits[index + 2]}/>
                  : <AppCol className={stylesServices.emptyTuileContainer}/>}
              </AppRow>
            )}
          </span>)
        )
      ) : (
        <span>
          {t("favoris.liste.vide",
            {
              "icon": <AppIcon
                title={"addFavori"}
                name="star-empty"
                size="15px" />
            }
          )}
        </span>
      )}
    </>
  )
};

export default ListeFavoris;